import type { AssetId } from '../assets/types';
import type { Region } from '../utils/geometry';

export interface BiomeSpeciesEntry {
  modelId: AssetId;
  /** Relative weight within this biome's species mix — doesn't need to sum to 1. */
  weight: number;
}

export interface BiomeDef {
  id: string;
  /** Where this biome applies. If omitted, BiomeRenderer uses the whole course's bounds. */
  region?: Region;
  speciesMix: BiomeSpeciesEntry[];
  /** Roughly instances per square world-unit — small numbers (0.01–0.05) are normal. */
  density: number;
  seed: number;
  scaleVariation: { min: number; max: number };
  rotationVariation: boolean;
}

/**
 * Pure data, same role as VegetationField/WaterFeature: a Biome describes
 * *how* to populate vegetation (what species, how dense, how varied) —
 * BiomeRenderer is what actually generates instances from it. Course owns
 * a list of these instead of (or alongside) hand-placed VegetationField
 * instances, so background vegetation is generated at load time rather
 * than authored object-by-object.
 */
export class Biome {
  constructor(readonly def: BiomeDef) {}
}
